import VaxOverview from 'components/impfschaeden/uebersicht/VaxOverview.js';
import HeaderImage from 'components/layout/Header/components/HeaderImage.js';

const OverView = () => {
	return (
		<div>
			<HeaderImage />
			<VaxOverview />
		</div>
	);
};

export default OverView;
